export default "__VITE_ASSET__CRUnuxwW__"